<script setup>
import {computed, ref, watch} from "vue";
import {useStore} from 'vuex';
import EODNav from "@components/reports/Manager/EODNav.vue";

const externalVisible = ref(false);

const store = useStore();
const user = computed(() => store.state.user)
// Making isManager work
const isManager = computed(() => {
  return user.value
      && Object.entries(user.value).length !== 0
      && (user.value['allcaps']['sb_manager_role']
          || user.value['allcaps']['administrator'])
})
</script>

<template>
  <div class="flex flex-col my-4 gap-4 items-center w-full">
    <EODNav v-if="isManager" :externalVisible @hide="externalVisible = false"/>
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component"/>
      </transition>
    </router-view>
  </div>
</template>

<style scoped>
:deep(.sleek-input > input ) {
  text-align: center;
  font-size: 14px;
  padding: 0 3px;
  width: 2rem;
}

:deep( .sleek-input > p ) {
  border-color: #6ca750;
}

/* Fix for tabs scrolling */
:deep(.tabs-container .p-tabview-nav-container) {
  overflow-x: auto;
}

:deep(.tabs-container .p-tabview-nav) {
  flex-wrap: nowrap;
  min-width: max-content;
}

:deep(.p-tabview-panels) {
  overflow-x: hidden;
}
</style>

